export default "__VITE_ASSET__DJ5yhMUB__"